@if (overlayOpen) {
  <div
    class="city-onboarding-backdrop"
    role="dialog"
    aria-modal="true"
    aria-labelledby="city-picker-title"
    (click)="onBackdropClick($event)"
  >
    <div class="city-onboarding-panel" (click)="$event.stopPropagation()">
      <div class="city-onboarding-panel-head">
        <!-- <h2 id="city-picker-title" class="city-onboarding-title">Choose your city</h2> -->
        <div class="city-picker-search-wrap">
          <input
            type="search"
            class="city-picker-search-input"
            [(ngModel)]="citySearch"
            placeholder="Search for your city"
            autocomplete="off"
            aria-label="Search cities"
          />
        </div>
        @if (cityService.getSelectedCity()) {
          <button
            type="button"
            class="city-onboarding-close"
            (click)="dismiss()"
            aria-label="Close"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        }
      </div>

      <!-- Before detecting -->
      <div
        class="detect-location cursor-pointer"
        (click)="detectLocation()"
        *ngIf="!detectingUserLocation && !dectedLocation"
      >
        <i class="pi pi-map-marker"></i>
        <span>Detect your location</span>
      </div>

      <!-- While detecting -->
      <div class="detect-location" *ngIf="detectingUserLocation">
        <i class="pi pi-map-marker"></i>
        <span>Detecting your location...</span>
      </div>

      <!-- After location detected -->
      <div
        class="detect-location cursor-pointer"
        (click)="detectLocation()"
        *ngIf="!detectingUserLocation && dectedLocation"
      >
        <i class="pi pi-map-marker"></i>
        <span>{{ dectedLocation }}</span>
      </div>

      @if (detectLocationError) {
        <div class="detect-location-error" role="alert">
          <span>{{ detectLocationError }}</span>
          <button
            type="button"
            class="detect-location-retry"
            (click)="detectLocation()"
          >
            Retry
          </button>
        </div>
      }

      @if (cityService.isLoadingCities && cityService.cities.length === 0) {
        <div class="city-onboarding-skeleton" aria-hidden="true">
          @for (i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; track i) {
            <div class="city-skel-item"></div>
          }
        </div>
      } @else if (
        !cityService.isLoadingCities && cityService.cities.length === 0
      ) {
        <p class="city-onboarding-empty">
          Cities could not be loaded. Check your connection and refresh.
        </p>
      } @else if (filteredCities.length === 0) {
        <p class="city-onboarding-empty">
          No cities match “{{ citySearch.trim() }}”. Try another search.
        </p>
      } @else {
        @if (citySearch.trim()) {
          <div
            class="city-picker-menu"
            role="listbox"
            [attr.aria-label]="'Cities, ' + filteredCities.length + ' results'"
          >
            @for (city of filteredCities; track city.id) {
              <button
                type="button"
                class="city-dropdown-item"
                role="option"
                (click)="pickCity(city,'user')"
              >
                @if (city["icon"]) {
                  <img
                    class="city-dropdown-icon"
                    [src]="city['icon']"
                    [alt]="city.name + ' icon'"
                    loading="lazy"
                  />
                } @else {
                  <span class="city-dropdown-flag" aria-hidden="true">{{
                    getCityFlag(city)
                  }}</span>
                }
                <span class="city-dropdown-name">{{ city.name }}</span>
              </button>
            }
          </div>
        } @else {
          <div class="city-popular-head">Popular Cities</div>
          <div
            class="city-popular-grid"
            role="listbox"
            aria-label="Popular cities"
          >
            @for (city of popularCities; track city.id) {
              <button
                type="button"
                class="city-popular-card"
                role="option"
                (click)="pickCity(city,'user')"
              >
                @if (city["icon"]) {
                  <img
                    class="city-popular-icon"
                    [src]="city['icon']"
                    [alt]="city.name + ' icon'"
                    loading="lazy"
                  />
                } @else {
                  <div class="city-popular-fallback" aria-hidden="true">
                    {{ getCityFlag(city) }}
                  </div>
                }
                <div class="city-popular-name" [class.active]="dectedLocation.toLowerCase()===city.name?.toLowerCase() || userSelectedLocation.toLowerCase()===city.name?.toLowerCase() ">{{ city.name }}</div>
              </button>
            }
          </div>

          <button type="button" class="city-view-all" (click)="toggleViewAll()">
            {{ showAllCities ? "Hide All Cities" : "View All Cities" }}
          </button>

          @if (showAllCities) {
            <div class="city-other-head">Other Cities</div>
            <div
              class="city-other-list"
              role="listbox"
              [attr.aria-label]="
                'All cities, ' + filteredCities.length + ' results'
              "
            >
              @for (city of filteredCities; track city.id) {
                <button
                  type="button"
                  class="city-other-item"
                  role="option"
                 (click)="pickCity(city,'user')"
                  [class.active]="dectedLocation.toLowerCase()===city.name?.toLowerCase() || userSelectedLocation.toLowerCase()===city.name?.toLowerCase() "
                >
                @if(city?.name){
                  {{ city.name }}
                }
                </button>
              }
            </div>
          }
        }
      }
    </div>
  </div>
}
